import { Button, Modal } from 'gatorcomponents';
import * as Styles from './ReinforcementModal.styles';
import React from 'react';

const ReinforcementModal = ({
  title,
  description,
  originalDomainName,
  newDomain,
  onClose,
  onContinue,
  continueLabel,
  cancelLabel,
}) => {
  const handleCancel = () => {
    onClose && onClose();
  };

  const handleContinue = () => {
    onContinue && onContinue();
    onClose && onClose();
  };

  return (
    <Modal
      title={title}
      maxWidth={900}
    >
      <Styles.ModalContent>
        <Styles.Description>{description[0]({ originalDomainName, newDomain })}</Styles.Description>
        <Styles.Description>{description[1]}</Styles.Description>
      </Styles.ModalContent>

      <Styles.ActionsRow>
        <Button size="large" variant="secondary" label={cancelLabel} onClick={handleCancel} />
        <Button size="large" label={continueLabel} onClick={handleContinue} />
      </Styles.ActionsRow>
    </Modal>
  );
};

export default ReinforcementModal;
